import { configureStore } from "@reduxjs/toolkit";
import { EnvConstant } from "../const";
import { useDispatch, useSelector, useStore } from "react-redux";
import createSagaMiddleware from "redux-saga";
import rootSaga from "../sagas";
import authReducer from "./auth.slice";
import commonReducer from "./common.slice";
import homeReducer from "./home.slice";
/* ------------- Assemble The Reducers ------------- */
const reducer = {
  authReducer,
  commonReducer,
  homeReducer,
};
/* ------------- Saga Middleware ------------- */
// const sagaMiddleware = createSagaMiddleware();

// Create store
// const store = configureStore({
//   reducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({ serializableCheck: false }).concat(sagaMiddleware),
//   devTools: EnvConstant.IS_DEV,
// });

// // kick off root saga
// sagaMiddleware.run(rootSaga);

// export type IAppReduxState = ReturnType<typeof store.getState>;

// export type AppDispatch = typeof store.dispatch;

// export const useAppDispatch = () => useDispatch<AppDispatch>();

// export const useAppSelector: TypedUseSelectorHook<IAppReduxState> = useSelector;

// export default store;
const sagaMiddleware = createSagaMiddleware();

export const makeStore = () => {
  const store = configureStore({
    reducer,
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }).concat(sagaMiddleware),
    devTools: EnvConstant.IS_DEV,
  });
  sagaMiddleware.run(rootSaga);
  return store;
};
// kick off root saga
// sagaMiddleware.run(rootSaga);
export type AppStore = ReturnType<typeof makeStore>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();
